/**
 * 将本地存储中给定键名的值设为给定的数据。
 *
 * @category 存储
 * @param key 要存储的键名。
 * @param data 要存储的数据。
 * @example
 * ```javascript
 * setLocalStorage('token', '1234');
 * setLocalStorage('userInfo', {
 *   name: '发条方',
 *   gender: 'male',
 * });
 * ```
 */
export function setLocalStorage(key, data) {
    return localStorage.setItem(key, JSON.stringify(data));
}
